<!-- @format -->

<template>
  <div class="home">
    <div class="client-container">
      <div
        class="cbg"
        :style="
          'background: url(' +
            partnerBackgroundUrl +
            ') center center; background-size: cover;'
        "
      ></div>
      <div class="cbgmenu"></div>
      <div class="ui twelve column padded grid centered">
        <div class="row">
          <div class="twelve wide column">
            <div>
              <h2>Portfolios</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="twelve wide column">
            <div class="ui secondary pointing menu">
              <a
                class="ui item"
                v-bind:style="
                  status == 1
                    ? 'border-width: medium;border-color:#000000!important'
                    : ''
                "
                v-bind:class="{ active: status == 1 }"
                @click.prevent="getResults(1, 1)"
              >
                <i class="ui icon circle" style="color: green"></i> Active</a
              >
              <a
                class="ui item"
                v-bind:style="
                  status == 0
                    ? 'border-width: medium;border-color:#000000!important'
                    : ''
                "
                v-bind:class="{ active: status == 0 }"
                @click.prevent="getResults(1, 0)"
              >
                <i class="ui icon circle" style="color: red"></i> Archived</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui column very padded grid centered">
      <div class="row">
        <div class="twelve wide column">
          <div class="ui raised padded text segment">
            <h1 class="ui header">Portfolios</h1>
            <span> Portfolios and their associated risk profiles </span>

            <div
              v-if="currencies.length > 1"
              class="ui small secondary pointing menu"
            >
              <a
                v-for="c in currencies"
                class="item"
                v-bind:class="{ active: c == selectedCurrency }"
                @click.prevent="changeCurrency(c)"
                >{{ c }}</a
              >
            </div>

            <table class="ui compact table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Risk Profile</th>
                  <th>Status</th>
                  <th>Manage</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="5">
                    <div
                      class="hollow-dots-spinner"
                      v-if="loading"
                      :style="spinnerStyle"
                    >
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </div>
                  </td>
                </tr>
                <tr
                  v-for="p in order(
                    filteredCustomPortfolios,
                    'isLocked',
                    'desc'
                  )"
                  :key="p.id"
                >
                  <td style="vertical-align: top">
                    <strong>{{ p.portfolioName }}</strong>
                    <br />
                    <small
                      v-if="pw.weight != 0 && p.isLocked == false"
                      v-for="pw in p.portfolioWeight"
                    >
                      - {{ pw.weight }}%
                      {{ pw.underlyingPortfolio.portfolioName }}
                      <br />
                    </small>
                  </td>
                  <td style="vertical-align: top">
                    {{ p.isLocked ? "Default" : "Custom" }}
                  </td>
                  <td style="vertical-align: top">
                    {{ p.riskProfile.riskProfileName }}
                  </td>
                  <td style="vertical-align: top">
                    <span>{{ p.status == 0 ? "InActive" : "Active" }}</span>
                  </td>
                  <td style="vertical-align: top">
                    <router-link
                      v-if="p.isLocked == false"
                      class="ui small button"
                      :to="'/mapping/' + p.currency + '/' + p.id"
                      >Edit</router-link
                    >
                    <div
                      v-if="p.status == 1"
                      class="ui tiny button"
                      @click="makeInactive(p)"
                    >
                      Make Inactive
                    </div>
                    <div
                      v-else
                      class="ui tiny green button"
                      @click="makeInactive(p)"
                    >
                      Make Active
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <router-link v-if="appName != 'QuestLink'"
              class="ui primary small button"
              :to="'/mapping/' + selectedCurrency + '/' + 0"
              >New Custom Portfolio</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";

import { getCustomPortfolios, createOrUpdateCustomPortfolio } from "@/gateway";
export default {
  name: "CustomPortfolioList",

  data() {
    return {
      loading: false,
      status: 1,
      results: [],
      allRecords: [],
      searchText: "",
      selectedCurrency: "ZAR",
      totalRecords: 0,
      currentPageNr: 1,
      currentPageSize: 8,
      totalPages: 1,
    };
  },
  computed: {
    filteredCustomPortfolios() {
      if (this.results.length > 0)
        return _.filter(this.results, { currency: this.selectedCurrency });

      return [];
    },
    currencies() {
      if (this.results.length > 0)
        return _.uniq(_.map(this.results, "currency"));
      else return [];
    },
    partnerBackgroundUrl() {
      if (this.$store.state.partnerBackgroundUrl)
        return this.$store.state.partnerBackgroundUrl;
      else return "";
    },
  },
  methods: {
    async changeCurrency(currency) {
      this.selectedCurrency = currency;
    },
    map: function(arr, obj) {
      return _.map(arr, _.partialRight(_.pick, obj));
    },
    order: function(arr, v, v2) {
      return _.orderBy(arr, [v], [v2]);
    },
    flatten: function(arr) {
      return _.flattenDeep(arr);
    },
    filter: function(arr, filtr) {
      return _.filter(arr, filtr);
    },
    take: function(arr, size) {
      return _.take(arr, size);
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },
    async getResults(pageNr, currentStatus) {
      this.loading = true;
      this.status = currentStatus;
      this.loading = true;
      var response = await getCustomPortfolios({
        searchText: this.searchText,
        pageSize: this.currentPageSize,
        pageNr: pageNr,
        status: currentStatus,
        loadUnderlyingData: false,
      });

      if (response) {
        this.totalRecords = response.totalRecords;
        this.totalPages = response.totalPages;
        this.currentPageNr = response.currentPageNr;
        this.results = response.result;

        var response2 = await getCustomPortfolios({
          searchText: this.searchText,
          pageSize: 1000,
          pageNr: 1,
          loadUnderlyingData: false,
        });
        this.allRecords = response2.result;

        this.loading = false;
      }
    },
    async makeInactive(cp) {
      var cpRequest = cp;
      if (cp.status == 1) cpRequest.status = 0;
      else cpRequest.status = 1;
      const response = await createOrUpdateCustomPortfolio({
        customPortfolio: cpRequest,
        id: cpRequest.id,
      });
      this.getResults(1, this.status);
    },
  },
  mounted: function() {
    this.getResults(1, this.status);
  },
};
</script>
